import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_react_dom_7136dc57__ from "react-dom";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
const ScrollFade = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, showTop = true, showBottom = true, showLeft = false, showRight = false, fadeHeight = 24, fadeWidth = 24, fadeColor = "from-grayscale-darker" }, _ref)=>{
    const [canScrollUp, setCanScrollUp] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const [canScrollDown, setCanScrollDown] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const [canScrollLeft, setCanScrollLeft] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const [canScrollRight, setCanScrollRight] = __WEBPACK_EXTERNAL_MODULE_react__.useState(false);
    const anchorRef = __WEBPACK_EXTERNAL_MODULE_react__.useRef(null);
    const [scrollableParent, setScrollableParent] = __WEBPACK_EXTERNAL_MODULE_react__.useState(null);
    const checkScroll = __WEBPACK_EXTERNAL_MODULE_react__.useCallback(()=>{
        if (!scrollableParent) return;
        const { scrollTop, scrollHeight, clientHeight, scrollLeft, scrollWidth, clientWidth } = scrollableParent;
        setCanScrollUp(scrollTop > 0);
        setCanScrollDown(scrollTop + clientHeight < scrollHeight - 1);
        setCanScrollLeft(scrollLeft > 0);
        setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
    }, [
        scrollableParent
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        const findScrollableParent = (element)=>{
            if (!element) return null;
            const { overflow, overflowY, overflowX } = window.getComputedStyle(element);
            if ("auto" === overflow || "scroll" === overflow || "auto" === overflowY || "scroll" === overflowY || "auto" === overflowX || "scroll" === overflowX) return element;
            return findScrollableParent(element.parentElement);
        };
        const parent = findScrollableParent(anchorRef.current);
        if (!parent) return;
        setScrollableParent(parent);
        checkScroll();
        parent.addEventListener("scroll", checkScroll, {
            passive: true
        });
        window.addEventListener("resize", checkScroll);
        const observer = new ResizeObserver(checkScroll);
        observer.observe(parent);
        return ()=>{
            parent.removeEventListener("scroll", checkScroll);
            window.removeEventListener("resize", checkScroll);
            observer.disconnect();
        };
    }, [
        checkScroll
    ]);
    const fadeColorClass = fadeColor || "from-grayscale-darker";
    const fadeElements = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            showTop && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("absolute top-0 left-0 right-0 pointer-events-none z-10 transition-opacity duration-200", `bg-gradient-to-b ${fadeColorClass} to-transparent`, canScrollUp ? "opacity-100" : "opacity-0", className),
                style: {
                    height: `${fadeHeight}px`
                }
            }),
            showBottom && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("absolute bottom-0 left-0 right-0 pointer-events-none z-10 transition-opacity duration-200", `bg-gradient-to-t ${fadeColorClass} to-transparent`, canScrollDown ? "opacity-100" : "opacity-0", className),
                style: {
                    height: `${fadeHeight}px`
                }
            }),
            showLeft && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("absolute top-0 bottom-0 left-0 pointer-events-none z-10 transition-opacity duration-200", `bg-gradient-to-r ${fadeColorClass} to-transparent`, canScrollLeft ? "opacity-100" : "opacity-0", className),
                style: {
                    width: `${fadeWidth}px`
                }
            }),
            showRight && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("absolute top-0 bottom-0 right-0 pointer-events-none z-10 transition-opacity duration-200", `bg-gradient-to-l ${fadeColorClass} to-transparent`, canScrollRight ? "opacity-100" : "opacity-0", className),
                style: {
                    width: `${fadeWidth}px`
                }
            })
        ]
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                ref: anchorRef,
                style: {
                    display: "contents"
                }
            }),
            scrollableParent && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_dom_7136dc57__.createPortal)(fadeElements, scrollableParent)
        ]
    });
});
ScrollFade.displayName = "ScrollFade";
export { ScrollFade };
